import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { AutoinvestmentsModeDisableAction } from 'components/features/rewards/rewardsPane/store/actions/autoInvestmentsMode'
import { FutureCheckbox } from 'components/features/future/FutureCheckbox/FutureCheckbox'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { FC, useCallback, useState } from 'react'
import styles from 'components/features/rewards/rewardPageSummary/AutoinvestTurnOffButton/AutoinvestTurnOffButton.styl'


export const AutoinvestTurnOffButton: FC = () => {
  const [isPending, setIsPending] = useState(false)
  const dispatch = useStoreDispatch()
  const handleClick = useCallback(() => {
    setIsPending(true)
    dispatch(new AutoinvestmentsModeDisableAction())
  }, [dispatch])

  return (
    <button disabled={ isPending } className={ styles.disableAutoinvestButton } onClick={ handleClick }>
      { isPending && <LoadingOverlay />}
      <span className={ styles.label }>Auto-invest earned rewards</span>
      <FutureCheckbox disabled={ isPending } defaultChecked />
      <span className={ styles.labelOn }>On</span>
    </button>
  )
}
